/* changeorders — the "change order awaiting approval" hold.
   A pending change order means the scope and the price aren't settled, so
   production shouldn't be scheduled or started until the customer signs it.
   The office can push forward anyway, but has to confirm once; that
   confirmation is stamped on the work order (coHoldOverride) so the banner
   reads "proceeding without approval" instead of nagging on every click. */
import { confirmDialog } from "../components";

export function pendingCOs(q: any): any[] {
  const cos = q && Array.isArray(q.changeOrders) ? q.changeOrders : [];
  return cos.filter((c: any) => c && c.status === "pending");
}
export function coHold(wo: any, store: any) {
  const q = wo && (store && store.quotes || []).find((x: any) => x && x.id === wo.quoteId);
  const pending = pendingCOs(q);
  const sum = pending.reduce((s: number, c: any) => s + (Number(c.amount) || 0), 0);
  // an override only covers the change orders that existed when it was given
  const ids = pending.map((c: any) => c.id).sort().join(",");
  const ov = wo && wo.coHoldOverride;
  const overridden = !!(ov && ov.ids === ids);
  return { q, pending, sum, ids, overridden, override: overridden ? ov : null, active: pending.length > 0 && !overridden };
}
const money0 = (n: number) => "$" + Math.round(Math.abs(Number(n) || 0)).toLocaleString("en-US");
/* true = go ahead. Confirms once per set of pending change orders. */
export async function confirmCoHold(wo: any, store: any, action: string): Promise<boolean> {
  const h = coHold(wo, store);
  if (!h.active) return true;
  const who = (h.q && h.q.customer) || wo.customer || "the customer";
  const list = h.pending.map((c: any) => `${c.label} (${(Number(c.amount) || 0) >= 0 ? "+" : "−"}${money0(c.amount)})`).join("; ");
  const ok = await confirmDialog({
    title: `Change order awaiting ${who}'s approval`,
    body: `${list}. The price and scope aren't settled until ${who} signs it on the portal. ${action} anyway? This is recorded on the job.`,
    confirmLabel: action + " anyway", danger: true,
  });
  if (!ok) return false;
  if (store && store.updateWorkOrder) store.updateWorkOrder(wo.id, { coHoldOverride: { at: Date.now(), ids: h.ids, action } });
  if (store && store.addActivity) store.addActivity(`${action} ${wo.customer || wo.title || "job"} with a change order still awaiting approval`);
  return true;
}
